import * as f from '../../../components/BPMTable/BPMInputs'
import {
    TableFieldDescription,
    DataMapper,
} from  '../../../components/BPMTable/TableMapperCreator'
import TableCreatorCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import { DirectTableQueryBuilder } from "../../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder"
import tableCreatorCreatorFactoryCreator from '../../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'


const unitQuery = `
    inventoryTypeModel(id: $id) {
        id
        type
        technology {
            name
            id
        }
    }
`

const queries = {tableQueryBuilder: new DirectTableQueryBuilder('allInventoryTypes'), unitQuery}

class InventoryTypeMinimalTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "InventoryTypeMinimalTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator =  this.createTableCreator(this.constructor.getId(), tableName, queries)
        tableCreator.setAdditionalFilters(this.filters)
        tableCreator.addDescriptions([
            new TableFieldDescription(
                'name',
                new DataMapper("name"),
                new f.FilterDescription(new f.TextFilter("name")),
                {label: 'Name'}
            ),
            new TableFieldDescription(
                'technology',
                new DataMapper("technology.name"),
                new f.FilterDescription(new f.TextFilter("technology")),
                {label: 'Technology'}
            )
        ])
        
        return tableCreator;
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(InventoryTypeMinimalTableCreator)

export default InventoryTypeMinimalTableCreator;